/** Requester-facing status chip — colour by CATEGORY (the engine's stable
 *  semantics), label by the org's own status name. One saturated accent per
 *  row, per the idiom: amber = waiting, emerald = resolved. */
import { Badge } from '../../components/ui/badge';
import { cn } from '../../lib/utils';

const CATEGORY_STYLE: Record<string, string> = {
  open: 'bg-brand/10 text-brand',
  pending: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
  resolved: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
  closed: 'bg-muted text-muted-foreground',
};

export function StatusChip({ status, category }: { status: string | null; category: string | null }) {
  if (!status) return null;
  return (
    <Badge className={cn('border-transparent', CATEGORY_STYLE[category ?? ''] ?? 'bg-muted')}>{status}</Badge>
  );
}
